import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getWeeks, deleteWeek } from "./api";

export default function WeeksList() {

  const [weeks, setWeeks] = useState([]);
  const navigate = useNavigate();

  const API_BASE_URL = `${process.env.REACT_APP_API_URL ?? ""}/api`;

  const fetchWeeks = async () => {
    try {
      const w = await getWeeks();
      setWeeks(w);
    } catch (err) {
      console.error("Failed to load weeks", err);
    }
  };

  useEffect(() => {
    fetchWeeks();
  }, []);

  const removeWeek = async (weekId) => {
    if (!window.confirm("Are you sure you want to delete this week? This action cannot be undone.")) {
      return;
    }

    try {
      await deleteWeek(weekId);
      setWeeks(prev => prev.filter(w => w.id !== weekId));
    } catch (err) {
      alert("Failed to delete week");
      console.error(err);
    }
  };

  const formatNumber = (value) =>
    value ? value.toLocaleString() : "0";

  function formatDate(dateInput) {
    const d = new Date(dateInput);
    if (isNaN(d)) return ""; // fallback for invalid dates

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  }

  return (
    <Container>

      <Typography variant="h4" sx={{ mb: 3 }}>
        Weeks
      </Typography>

      <Paper>

        <Table>

          <TableHead>
            <TableRow>
              <TableCell>Week</TableCell>
              <TableCell>Date Range</TableCell>
              <TableCell align="right">Opening Balance</TableCell>
              <TableCell align="right">Income</TableCell>
              <TableCell align="right">Expenses</TableCell>
              <TableCell align="right">Net</TableCell>
              <TableCell align="right">Closing Balance</TableCell>
              <TableCell align="right">Edit</TableCell>
              <TableCell align="right">Delete</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {weeks.map((week) => {

              return (
                <TableRow
                  key={week.id}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() => navigate(`/accounting/${week.id}`)}
                >

                  <TableCell>
                    {week.year}-W{week.week_number}
                  </TableCell>

                  <TableCell>
                    {new Date(week.start_date).toLocaleDateString('et-EE')}&nbsp;&mdash;&nbsp;
                    {new Date(week.end_date).toLocaleDateString('et-EE')}
                  </TableCell>

                  <TableCell align="right"
                    sx={{
                      color: week.opening_balance >= 0 ? "green" : "red",
                      fontWeight: 600
                    }}>
                    {formatNumber(week.opening_balance)}
                  </TableCell>

                  <TableCell align="right">
                    {formatNumber(week.income)}
                  </TableCell>

                  <TableCell align="right">
                    {formatNumber(week.expenses)}
                  </TableCell>

                  <TableCell
                    align="right"
                  >
                    {formatNumber(week.net)}
                  </TableCell>

                  <TableCell align="right"
                    sx={{
                      color: week.closing_balance >= 0 ? "green" : "red",
                      fontWeight: 600
                    }}>
                    {formatNumber(week.closing_balance)}
                  </TableCell>

                  <TableCell align="right">
                    <a
                      href={`/weeks/${week.id}`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      Edit
                    </a>
                  </TableCell>

                  <TableCell align="right">
                    <a href="#" onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      removeWeek(week.id);
                    }}>
                      Delete
                    </a>
                  </TableCell>

                </TableRow>
              );
            })}
          </TableBody>

        </Table>

      </Paper>

    </Container>
  );
}